module.exports = __webpack_public_path__ + "e8870da6fd54da6618dc52d6f621b14a.svg";